import router from '../router';

const goto = (pageName, options) => {
  let route = { name: pageName };
  if (typeof options === 'object') {
    route = { ...route, ...options };
  }
  console.log('route', route);
  router.push(route).catch(error => {
    if (error.name === 'NavigationDuplicated') return;
    throw error;
  });
};

const navigation = {
  setup(namespace, root) {
    const { handlers, shortcuts } = this;
    Object.keys(handlers).forEach(handlerName => {
      root.on(`${namespace}.${handlerName}`, this.handlers[handlerName]);
    });
    // setup shortcuts
    Object.keys(shortcuts).forEach(shortcut => {
      root[shortcut] = shortcuts[shortcut]; // eslint-disable-line
    });
  },
  handlers: {
    goto,
  },
  shortcuts: {
    goto(pageName, options) {
      goto(pageName, options);
    },
  },
};

export default navigation;
